import { useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface BrandedLogoProps {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  fallback?: React.ReactNode;
  loading?: boolean;
}

/**
 * Renders an org/client logo with:
 * - Skeleton placeholder while loading
 * - onError fallback (hides broken images)
 * - Optional fallback component when no src
 */
export function BrandedLogo({
  src,
  alt = "Organization",
  className = "h-10 w-auto",
  fallback = null,
  loading = false,
}: BrandedLogoProps) {
  const [imgError, setImgError] = useState(false);

  if (loading) {
    return <Skeleton className="h-10 w-32 rounded" />;
  }

  if (!src || imgError) {
    return <>{fallback}</>;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setImgError(true)}
    />
  );
}
